import { get } from 'lodash';
import Services from 'services';

export const getUsefulBanner = async params => {
  const response = await Services.isnGet(`/api/usefulinformation/get-banner${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getUsefulMenu = async params => {
  const response = await Services.isnGet(`/api/usefulinformation/get-by-category${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getTopics = async params => {
  const response = await Services.isnGet(`/api/usefulinformation/topics${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getDistricts = async params => {
  const response = await Services.isnGet(`/api/usefulinformation/get-districts${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getDetailTopic = async params => {
  const response = await Services.isnGet(`/api/usefulinformation/details-topic${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getRentalFlow = async params => {
  const response = await Services.isnGet(`/api/usefulinformation/get-rentals${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getUsefulFaq = async params => {
  const response = await Services.isnGet(`/api/usefulinformation/get-faq${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getSupportServiceBanner = async params => {
  const response = await Services.isnGet(`/api/usefulinformation/get-support-services-banner${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getRetalBanner = async params => {
  const response = await Services.isnGet(`/api/usefulinformation/get-rentals-banner${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getRentingBanner = async params => {
  const response = await Services.isnGet(`/api/owners/get-banner-for-rent${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};
